export default __webpack_public_path__ + "static/media/thumbnail-class.edecfa89.png";